<template>
<div class="eChart">
    <div class="title1">
      <span class="fl tip">成绩分档统计</span>
    </div>
    <div id="myChartpie" style="width: 800px;height: 330px;"></div>
  </div>
</template>
<script>
export default {
  props: ['echartData'],
  data() {
    return {
    }
  },
  watch: {
    echartData(curVal,oldVal){
      console.log(curVal, 'oooo')
      // if (curVal !== oldVal) {
      // }
      this.setOption(curVal)
    }
  },
  created() {
    this.$nextTick(() => {
      this.setOption(this.echartData)
    })
  },
  methods: {
    setOption (curData) {
      let legendData = ['未提交', '不及格(0 -59)', '合格(60-69)', '中等(70-79) ', '良好(80-90)', '优秀(90-100)']
      let seriesData = []
      curData.map(item => {
        let objS = {
          value: item.rate,
          name: legendData[item.status]
        }
        seriesData.push(objS)
      })
      this.drawLine(seriesData, legendData)
    },
     drawLine(seriesData, legendData) {
      let myChart = this.$echarts.init(document.getElementById('myChartpie'))
      myChart.setOption({
        //  tooltip: {
        //    trigger: 'item',
        //    formatter: "{b} : {c} ({d}%)"
        //  },
         legend: {
           orient: 'horizontal',
           selectedMode: false,
           padding: [5, 30],
           top: 'top',
           data: legendData
         },
         color: ['#D33636', '#079FA9', '#FA8000', '#FFCF07', '#8CD019', '#59BE4B'],
         series: [
           {
             name: '访问来源',
             type: 'pie',
             radius: '70%',
             center: ['50%', '60%'],
             data: seriesData,
             clickable: false,
             hoverAnimation: false,
             itemStyle: {
               normal: {
                 label: {
                   show: true,
                   formatter: "{b} {c}%"
                 },
                 labelLine: { show: true }
               }
             }
           }
         ]
       });
    },
    changetype (data, i) {
      this.subjectName = data
      this.subjectF = false
      this.$emit('setresourceType', i)
    },
    selectShow () {
      this.subjectF = true
    }
  }
};
</script>



// WEBPACK FOOTER //
// echartPie.vue?75b9c520